import React from "react";

interface Props {
  errors: string[];
}

export const FormErrorSummary: React.FC<Props> = ({ errors }) =>
  errors.length ? (
    <div className="form__error-summary" role="alert">
      <ul>
        {errors.map((e, i) => (
          <li key={i}>{e}</li>
        ))}
      </ul>
    </div>
  ) : null;
